import { Routes } from '@angular/router';

export const hoardingSiteRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/hoarding-site-list/hoarding-site-list.component').then(
        (m) => m.HoardingSiteListComponent
      )
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./pages/add-hoarding-site/add-hoarding-site.component').then(
        (m) => m.AddHoardingSiteComponent
      )
  },
  {
    path: 'edit/:id',
    loadComponent: () =>
      import('./pages/add-hoarding-site/add-hoarding-site.component').then(
        (m) => m.AddHoardingSiteComponent
      )
  }
];
